import { useTranslation } from 'react-i18next';
import { useSessionStore } from '@/entities/session/model/sessionStore';
import { useThemeStore } from '@/entities/session/model/themeStore';

export function Header() {
  const { t } = useTranslation();
  const currentContext = useSessionStore((s) => s.currentContext);
  const theme = useThemeStore((s) => s.theme);

  return (
    <header
      className="header-glass flex h-16 items-center justify-between border-b border-border px-6 transition-colors"
      style={{ background: 'var(--t-header-bg)' }}
    >
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <h1 className="truncate text-base font-semibold text-text-primary sm:text-lg">
            {t('header.cabinet')}
          </h1>
        </div>
        {currentContext && (
          <span className="rounded-md bg-primary-100 px-2 py-0.5 text-sm text-primary-700">
            {currentContext.name}
          </span>
        )}
      </div>

      <div className="flex items-center gap-4">
        <div
          className="flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold text-white"
          style={{
            background: theme === 'ultra'
              ? 'linear-gradient(135deg, #6c3aed, #ec4899)'
              : theme === 'aidd'
                ? 'linear-gradient(135deg, #ff5a00, #ff8a47)'
                : 'var(--t-primary-200)',
          }}
        >
          {theme !== 'classic' && t('header.aiBadge')}
        </div>
      </div>
    </header>
  );
}
